<template>
    <v-app id="mg_theme">
        <svg-sprites />
        <header-tag />

        <contact-banner />

        <v-container no-padding-y>
            <v-layout>
                <v-flex>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
        </v-container>

        <v-content>
            <nuxt />
        </v-content>

        <footer-tag />
    </v-app>
</template>

<script>
import SvgSprites from '~/components/SvgSprites'
import HeaderTag from '~/components/molecules/HeaderTag'
import FooterTag from '~/components/molecules/FooterTag'
import ContactBanner from '~/components/molecules/ContactBanner'

export default {
    name: 'App',
    components: { ContactBanner, FooterTag, HeaderTag, SvgSprites },
    head: { htmlAttrs: { lang: 'ja' } },
    data: () => ({
        transitionName: 'fade',
        breadcrumbs: [
            {
                text: 'HOME',
                disabled: false,
                href: 'https://motion-gallery.net/'
            },
            {
                text: 'お問い合わせ',
                disabled: true,
                to: '/'
            }
        ]
    })
}
</script>

<style lang="scss"></style>
